/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PageDto } from '../models/PageDto';
import type { PageDtoODataListResponse } from '../models/PageDtoODataListResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PagesService {

    /**
     * @param top The max number of records.
     * @param skip The number of records to skip.
     * @param filter A function that must evaluate to true for a record to be returned.
     * @param select Specifies a subset of properties to return. Use a comma separated list.
     * @param orderby Determines what values are used to order a collection of records.
     * @param expand Use to add related query data.
     * @param count Include the overall count
     * @returns PageDtoODataListResponse Success
     * @throws ApiError
     */
    public static getBackendPages(
top?: string,
skip?: string,
filter?: string,
select?: string,
orderby?: string,
expand?: string,
count?: string,
): CancelablePromise<PageDtoODataListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backend/Pages',
            query: {
                '$top': top,
                '$skip': skip,
                '$filter': filter,
                '$select': select,
                '$orderby': orderby,
                '$expand': expand,
                '$count': count,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns PageDto Success
     * @throws ApiError
     */
    public static postBackendPages(
requestBody?: PageDto,
): CancelablePromise<PageDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/backend/Pages',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns PageDto Success
     * @throws ApiError
     */
    public static getBackendPages1(
key: number,
): CancelablePromise<PageDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backend/Pages/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param key 
     * @param requestBody 
     * @returns PageDto Success
     * @throws ApiError
     */
    public static putBackendPages(
key: number,
requestBody?: PageDto,
): CancelablePromise<PageDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/backend/Pages/{key}',
            path: {
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns any Success
     * @throws ApiError
     */
    public static deleteBackendPages(
key: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/backend/Pages/{key}',
            path: {
                'key': key,
            },
        });
    }

}
